import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';

export function MarketingLayout() {
  const { t } = useTranslation();

  return (
    <div className="site">
      <a className="skip-link" href="#content">
        {t('nav.skip')}
      </a>
      <SiteHeader />
      <main id="content" tabIndex={-1}>
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
